import {
  AppliedFilter,
  AppliedFilter_RangeFilter,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {compareAsc} from '@aboutyou/utils';
import {parseAttributeFilterValue} from './parseQueryParamsFilterValues';

export const filtersToAppliedFilters = (
  appliedFilters: Map<string, Array<string> | undefined>,
) => {
  const filters: {[key: string]: AppliedFilter} = {};
  const prices: {max?: number; min?: number} = {};

  Array.from(appliedFilters.keys())
    .sort(compareAsc)
    .forEach(key => {
      const filterSectionValues = appliedFilters.get(key);

      if (!filterSectionValues || filterSectionValues.length === 0) return;

      if (key === 'prices' && filterSectionValues.length === 2) {
        const min = parseInt(filterSectionValues[0]!);
        const max = parseInt(filterSectionValues[1]!);

        if (!isNaN(min) && isFinite(min)) prices.min = min;
        if (!isNaN(max) && isFinite(max)) prices.max = max;
      } else if (key === 'discount' && filterSectionValues?.[0]) {
        const discountLevel = Number(filterSectionValues?.[0]);

        filters.discount = {
          filter: {
            $case: 'discountLevel',
            discountLevel: {
              discountLevel,
            },
          },
        };
      } else if (
        filterSectionValues.length === 1 &&
        (filterSectionValues[0] === 'false' ||
          filterSectionValues[0] === 'true')
      ) {
        filters[key] = {
          filter: {
            $case: 'boolean',
            boolean: {
              state: filterSectionValues[0] === 'true',
            },
          },
        };
      } else {
        filters[key] = {
          filter: {
            $case: 'attribute',
            attribute: {
              selectedValues: filterSectionValues
                .sort(compareAsc)
                .map(parseAttributeFilterValue)
                .filter(parsedVal => !isNaN(parsedVal)),
            },
          },
        };
      }
    });

  if (prices.max || prices.min) {
    filters.prices = {
      filter: {
        $case: 'range',
        range: prices as AppliedFilter_RangeFilter,
      },
    };
  }

  return filters;
};
